// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'


import MonthPicker from 'vue-month-picker'
import MonthPickerInput from 'vue-month-picker'

Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric)

import 'bootstrap/dist/css/bootstrap.css';
import '@/styles/custom.css';

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

import {ServerTable, ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable);
// Sync store with router
sync(store, router)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  
  
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } /*else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: 'home',
      })
    } else {
      next()
    }
  }*/ else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
